module.exports = __webpack_public_path__ + "static/img/a2.58e9035.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/index/a2.jpg
// module id = 5a3F
// module chunks = 202